import Repository from '@/repositories/marketing'
const resource = '/custom_fields'

export default {
    fetch (config) {
        return Repository.get(`${resource}.json`, config)
    },
    fetchDefaultFields(config) {
        return Repository.get(`show.json`, config)
    },
    createCustomField(config) {
        return Repository.post(`${resource}.json`,config)
    },
    editCustomFieldData (id)
    {
        return Repository.get(`${resource}/${id}.json`)
    },
    editCustomField (id ,payload)
    {
        return Repository.put(`${resource}/${id}.json`,payload)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    editDefaultField(payload)
    {
        return Repository.put(`update.json`,payload)
    }
}